/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleCircleSquare: {
  name: 'triangle-circle-square';
  data: string;
} = {
  name: 'triangle-circle-square',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 3a1 1 0 0 1 .894.553l3 6A1 1 0 0 1 15 11H9a1 1 0 0 1-.894-1.447l3-6A1 1 0 0 1 12 3Zm1.382 6L12 6.236 10.618 9h2.764ZM3 14a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-6Zm2 1v4h4v-4H5Zm10 2a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" fill="currentColor"/></svg>`,
};
